import * as Alert from '@/components/ui/alert'
import { IconButton } from '@/components/ui/icon-button'
import { Reply, X } from 'lucide-solid'
import { Show } from 'solid-js'
import { Motion, Presence } from 'solid-motionone'
import { useService } from 'solid-services'
import { generateParentPreviewText } from '../generateParentPreviewText'
import { useUpsert } from '../state'

export default function () {
  const { replyMessage, setReplyMessage } = useService(useUpsert)()

  const previewText = () => generateParentPreviewText(replyMessage()?.content)

  return (
    <Presence>
      <Show when={replyMessage()}>
        <Motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.25, easing: [0.4, 0, 0.2, 1] }}
          style={{ width: '100%' }}
        >
          <Alert.Root
            mx={3}
            borderBottomRightRadius={0}
            borderBottom={0}
            borderBottomLeftRadius={0}
            w="calc(100% - var(--spacing-8))"
            variant='outline'
            size='md'
            status='neutral'
            bg='bg.default'
          >
            <Alert.Indicator
              asChild={(iconProps) => (
                <Reply
                  size="16"
                  {...iconProps()}
                />
              )}
            />
            <Alert.Content
              position="relative"
              width="100%"
            >
              <Alert.Title textStyle={'sm'}>
                Reply to: {(replyMessage()?.profile as any)?.username}
              </Alert.Title>
              <Alert.Description>{previewText()}</Alert.Description>
              <IconButton
                onClick={() => setReplyMessage(undefined)}
                position="absolute"
                top="0"
                right="0"
                variant="outline"
                size="xs"
              >
                <X />
              </IconButton>
            </Alert.Content>
          </Alert.Root>
        </Motion.div>
      </Show>
    </Presence>
  )
}
